import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Corrected import path
import { Box, CircularProgress } from '@mui/material';

/**
 * ProtectedRoute Component
 *
 * Renders the child components only if the user is authenticated.
 * Otherwise, redirects the user to the home page ('/').
 * Shows a loading indicator while authentication status is being checked.
 *
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - The component(s) to render if authenticated.
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Show a loading spinner while checking auth status
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    // User not logged in, redirect them to the home page (Invitations)
    // Pass the current location in state in case we want to redirect back later (optional)
    return <Navigate to="/" state={{ from: location }} replace />;
    // Note: We could also show the login modal here, but redirecting is cleaner for direct URL access.
    // The AppBar modal handles the click-based prompt.
  }

  // User is logged in, render the requested component
  return children;
};

export default ProtectedRoute;